import { httpGet, httpPost, httpDownload } from '../../../../utils/api.utils';
import { DEFAULT_TABLE_RESULT_MODEL, Selected_Index } from '../../../../constants/external-constants';
import {
    getOutputConfigRechargeItems,
    setDefaultConfigRechargeItems,
    setConfigRechargeItemsError,
    setConfigRechargeItemsColSearchStr,
    sortConfigRechargeItemsItems,
    setConfigRechargeItemsPageSize
} from "../../../../constants/model-reducers/external/recharge/output-configuration/output-configuration-recharge-items.settings";
import { convertToFormatTimeZoneDate } from '../../../../utils/helpers.utils';

const defaultState = () => ({
    isConfigRechargeItemsLoaded: false,
    isConfigRechargeItemsError: false,
    configRechargeItemsItems: DEFAULT_TABLE_RESULT_MODEL,
    configRechargeItemsColSort: '',
    configRechargeItemsIsSortedAsc: false,
});

const initialState = defaultState();

export const outputConfigRechargeItemsActions = {
    setDefaultConfigRechargeItems: () => async (dispatch, state) => {
        dispatch({
            type: setDefaultConfigRechargeItems,
            configRechargeItemsItems: DEFAULT_TABLE_RESULT_MODEL
        });
    },
    getOutputConfigRechargeItems: (outputConfigurationId, pageIndex) => async (dispatch, state) => {
        const { Headers, Pagination } = state().outputConfigRechargeItems.configRechargeItemsItems;
        const { configRechargeItemsIsSortedAsc, configRechargeItemsColSort } = state().outputConfigRechargeItems;

        const userId = sessionStorage.getItem('UserID');

        try {
            const data = {
                PageFilter: {
                    PageIndex: pageIndex ?? 0,
                    PageSize: Pagination.PerPage,
                    PageSizes: Pagination.PageSizes
                },
                Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
                UserId: userId,
                EmployeeId: sessionStorage.getItem('EmployeeID'),
                Headers: {
                    ...Headers
                },
                SortedColumnName: configRechargeItemsColSort,
                IsSortAscending: configRechargeItemsIsSortedAsc,
            };

            let newConfigRechargeItemsItems = await httpPost('external/recharge/getConfigurationRechargeItems/' + outputConfigurationId, data);

            // Get previous headers from the state
            const previousHeaders = state().outputConfigRechargeItems.configRechargeItemsItems.Headers || {};
            const newHeaders = newConfigRechargeItemsItems?.Headers || {};

            // Merge search strings into new headers
            const mergedHeaders = {};
            for (const key in newHeaders) {
                mergedHeaders[key] = {
                    ...newHeaders[key],
                    searchString: previousHeaders[key]?.searchString || ''
                };
            }

            // Replace headers with merged ones
            newConfigRechargeItemsItems.Headers = mergedHeaders;

            dispatch({
                type: getOutputConfigRechargeItems,
                configRechargeItemsItems:
                    Object.keys(newConfigRechargeItemsItems).length > 0
                        ? newConfigRechargeItemsItems
                        : DEFAULT_TABLE_RESULT_MODEL,
                isConfigRechargeItemsLoaded: true,
                isConfigRechargeItemsError: false
            });
        } catch (e) {
            dispatch({
                type: setConfigRechargeItemsError,
                isConfigRechargeItemsError: true,
                isConfigRechargeItemsLoaded: false
            });
        }
    },
    getAllOutputConfigRechargeItemKeys: (outputConfigurationId) => async (dispatch, state) => {
        const { Headers } = state().outputConfigRechargeItems.configRechargeItemsItems;
        const { configRechargeItemsIsSortedAsc, configRechargeItemsColSort } = state().outputConfigRechargeItems;
        const userId = sessionStorage.getItem('UserID');

        try {
            const data = {
                PageFilter: {
                    PageIndex: 0,
                    PageSize: 0,
                    PageSizes: [0]
                },
                Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
                UserId: userId,
                EmployeeId: sessionStorage.getItem('EmployeeID'),
                Headers: {
                    ...Headers
                },
                SortedColumnName: configRechargeItemsColSort,
                IsSortAscending: configRechargeItemsIsSortedAsc,
            };

            const allKeys = await httpPost('external/recharge/getAllConfigurationRechargeItemKeys/' + outputConfigurationId, data);
            return allKeys ?? [];
        } catch (error) {
            console.error("Error fetching all recharge item keys:", error);
            return []; // fail gracefully
        }
    },
    getLatestInProgressOutputRecordName: (outputConfigurationId) => async (dispatch, state) => {
        try {
            const { recordName } = await httpGet('external/recharge/getLatestInProgressOutputRecordName/' + outputConfigurationId);
            return recordName ?? "";
        } catch (error) {
            console.error("Error fetching latest output record name:", error);
            return ""; // fail gracefully
        }
    },
    setConfigRechargeItemsColSearchStr: (event, key) => async (dispatch, state) => {
        const val = event.target.value;
        const { configRechargeItemsItems } = state().outputConfigRechargeItems;

        const updatedHeaders = {
            ...configRechargeItemsItems.Headers,
            [key]: {
                ...configRechargeItemsItems.Headers[key],
                searchString: val
            }
        };

        const configRechargeItemsItemsUpd = {
            ...configRechargeItemsItems,
            Headers: updatedHeaders
        };

        dispatch({
            type: setConfigRechargeItemsColSearchStr,
            data: configRechargeItemsItemsUpd,
            isConfigRechargeItemsError: false,
            isConfigRechargeItemsLoaded: true
        });
    },
    resizeConfigRechargeItemsPage: (pageSize) => async (dispatch, state) => {
        dispatch({
            type: setConfigRechargeItemsPageSize,
            pageSize: parseInt(pageSize),
        });
    },
    sortConfigRechargeItemsItems: (columnClicked, isSortedAsc, outputConfigurationId) => async (dispatch, state) => {
        const { PageNumber, PageSizes, PerPage } = state().outputConfigRechargeItems.configRechargeItemsItems.Pagination;
        const { configRechargeItemsItems } = state().outputConfigRechargeItems;

        var data = {
            PageFilter: {
                PageIndex: PageNumber !== undefined ? PageNumber : 0,
                PageSize: PerPage,
                PageSizes: PageSizes
            },
            Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
            UserId: sessionStorage.getItem('UserID'),
            EmployeeId: sessionStorage.getItem('EmployeeID'),
            Headers: {
                ...configRechargeItemsItems.Headers
            },
            SortedColumnName: columnClicked,
            IsSortAscending: isSortedAsc
        };

        var resConfigRechargeItemsItems = await httpPost('external/recharge/getConfigurationRechargeItems/' + outputConfigurationId, data);

        if (resConfigRechargeItemsItems.ok === false) {
            dispatch({
                type: setConfigRechargeItemsError,
                isRechargingInventoryError: true,
                isRechargingInventoryLoaded: false
            });
        } else {
            dispatch({
                type: sortConfigRechargeItemsItems,
                configRechargeItemsItems: Object.keys(resConfigRechargeItemsItems).length > 0 ? resConfigRechargeItemsItems : DEFAULT_TABLE_RESULT_MODEL,
                configRechargeItemsColSort: columnClicked,
                configRechargeItemsIsSortedAsc: isSortedAsc,
                isConfigRechargeItemsLoaded: true
            });
        }
    },
    deleteOutputConfigRechargeItems: (outputConfigurationId, keys, validate, currentPageIndex) => async (dispatch, getState) => {
        const userId = sessionStorage.getItem('UserID');
        const stagingId = parseInt(keys);
        try {
            const data = {
                OutputConfigurationId: outputConfigurationId,
                Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
                UserId: userId,
                EmployeeId: sessionStorage.getItem('EmployeeID'),
            };

            await httpPost(`external/recharge/deleteRechargeItem/${outputConfigurationId}/${stagingId}/${validate}`, data);

            const stateData = getState().outputConfigRechargeItems.configRechargeItemsItems;
            const totalRecordsBefore = stateData.Pagination?.TotalEntries ?? 0;
            const perPage = stateData.Pagination?.PerPage ?? 1;

            // After deleting 1 record
            const remainingRecords = Math.max(0, totalRecordsBefore - 1);
            const newLastPageIndex = remainingRecords > 0 ? Math.floor((remainingRecords - 1) / perPage) : 0;
            const targetPage = currentPageIndex > newLastPageIndex ? newLastPageIndex : currentPageIndex;

            // Refresh list after deletion
            dispatch(outputConfigRechargeItemsActions.getOutputConfigRechargeItems(outputConfigurationId, targetPage));
        } catch (error) {
            dispatch({
                type: setConfigRechargeItemsError,
                isConfigRechargeItemsError: true,
                isConfigRechargeItemsLoaded: false
            });
        }
    },
    clearOutputConfigRechargeItems: (outputConfigurationId, validate, keys, currentPageIndex) => async (dispatch, getState) => {
        const userId = sessionStorage.getItem('UserID');

        try {
            const data = {
                OutputConfigurationId: outputConfigurationId,
                RechargingOutputRecordStagingKeys: keys,
                Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
                UserId: userId,
                EmployeeId: sessionStorage.getItem('EmployeeID'),
            };

            await httpPost(`external/recharge/clearRechargeItems/${outputConfigurationId}/${validate}`, data);

            const stateData = getState().outputConfigRechargeItems.configRechargeItemsItems;
            const totalRecordsBefore = stateData.Pagination?.TotalEntries ?? 0;
            const perPage = stateData.Pagination?.PerPage ?? keys.length;
            const removedCount = keys.length;

            // How many records will be left after the clear
            const remainingRecords = Math.max(0, totalRecordsBefore - removedCount);
            const newLastPageIndex = remainingRecords > 0 ? Math.floor((remainingRecords - 1) / perPage) : 0;
            const targetPage = currentPageIndex > newLastPageIndex ? newLastPageIndex : currentPageIndex;

            // Refresh after clear
            dispatch(outputConfigRechargeItemsActions.getOutputConfigRechargeItems(outputConfigurationId, targetPage));
        } catch (error) {
            dispatch({
                type: setConfigRechargeItemsError,
                isConfigRechargeItemsError: true,
                isConfigRechargeItemsLoaded: false
            });
        }
    },
    updateOutputConfigRechargeItems: (outputConfigurationId, stagingId, validate, itemsToUpdate, currentPageIndex) => async (dispatch, state) => {
        const userId = sessionStorage.getItem('UserID');

        try {
            const data = {
                OutputConfigurationId: outputConfigurationId,
                Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
                UserId: userId,
                EmployeeId: sessionStorage.getItem('EmployeeID'),
                RechargingOutputRecordStagingUpdatedValues: itemsToUpdate
            };

            await httpPost(
                `external/recharge/updateRechargeItem/${outputConfigurationId}/${stagingId}/${validate}`,
                data
            );

            // Refresh after update
            dispatch(outputConfigRechargeItemsActions.getOutputConfigRechargeItems(outputConfigurationId, currentPageIndex));
        } catch (error) {
            dispatch({
                type: setConfigRechargeItemsError,
                isConfigRechargeItemsError: true,
                isConfigRechargeItemsLoaded: false
            });
        }
    },
    extractConfigRechargeItems: (outputConfigurationId, outputRecordID, id) => async (dispatch, state) => {
        const { Headers } = state().outputConfigRechargeItems.configRechargeItemsItems;
        const { configRechargeItemsIsSortedAsc, configRechargeItemsColSort } = state().outputConfigRechargeItems;

        const dealName = sessionStorage.getItem('DealName');
        const { activeDateFormat, activeTimeZoneOffset } = state().adminSetting;
        const formattedTimeZoneDate = convertToFormatTimeZoneDate(
            new Date(),
            activeDateFormat?.Name || "YYYY-MM-DD",
            activeTimeZoneOffset?.UtcOffset || 0)
            .replace(/[<>:"/\\|?*]/g, '-');

        let endpoint = '';
        let suffix = '';

        if (parseInt(id) === parseInt(Selected_Index.i_Zero)) {
            endpoint = 'external/recharge/getConfigurationRechargeItemsExtract/';
            suffix = 'All Columns';
        } else if (parseInt(id) === parseInt(Selected_Index.i_One)) {
            endpoint = 'external/recharge/getConfigurationOutputConfigurationRechargeItemsExtract/';
            suffix = 'Ouput Record Preview';
        }

        const filename = `ATEM ${dealName} Recharge Items - ${outputRecordID} - ${suffix} – ${formattedTimeZoneDate}`;

        var data = {
            Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
            UserId: sessionStorage.getItem('UserID'),
            EmployeeId: sessionStorage.getItem('EmployeeID'),
            Headers: {
                ...Headers
            },
            SortedColumnName: configRechargeItemsColSort,
            IsSortAscending: configRechargeItemsIsSortedAsc,
            FileName: filename
        };

        httpDownload(endpoint + outputConfigurationId, data)
            .then(function (response) {
                return response.blob();
            })
            .then(function (blob) {
                let downloadUrl = window.URL.createObjectURL(blob);
                //Hide Loading
                let a = document.createElement('a');
                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else if (typeof a.download === 'undefined') {
                    window.location = downloadUrl;
                } else {
                    a.href = downloadUrl;
                    a.download = filename + '.xlsx';
                    document.body.appendChild(a);
                    a.click();
                }
            });
    },
    getInProgressOutputRecordId: (outputConfigurationId) => async (dispatch, state) => {
        var action = await httpGet('external/recharge/getInProgressOutputRecordId/' + outputConfigurationId);

        return action.result;
    },
    performCommitOutputRecord: (outputConfigurationId, outputRecordID, uploadTypeId, fileFormatId, fileName, fileDelimeter, isGenerateJsonFile) => async (dispatch, state) => {
        try {
            var isGenerateJSONFileInt = isGenerateJsonFile === "true" ? 1 : 0;

            var customData = {
                RechargingOutputConfigurationID: outputConfigurationId,
                RechargingOutputRecordID: outputRecordID,
                FileFormatID: fileFormatId,
                FileNameString: fileName,
                FileDelimeter: fileDelimeter,
                IsGenerateJSONFile: isGenerateJSONFileInt
            };

            var data = {
                CreatedBy: sessionStorage.getItem('EID').toString(),
                UserId: sessionStorage.getItem('UserID').toString(),
                UploadTypeId: uploadTypeId,
                State: true,
                ChargeTypeDetails: JSON.stringify({
                    ...customData,
                }),
            };

            var result = await httpPost('external/recharge/commitOutput', data);

        }
        catch (e) {
            return e;
        }
        return result;
    }
};

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case getOutputConfigRechargeItems:
            return {
                ...state,
                configRechargeItemsItems: action.configRechargeItemsItems,
                isConfigRechargeItemsLoaded: action.isConfigRechargeItemsLoaded,
                isConfigRechargeItemsError: action.isConfigRechargeItemsError
            };
         case setConfigRechargeItemsError:
            return {
                ...state,
                isConfigRechargeItemsLoaded: action.isConfigRechargeItemsLoaded,
                isConfigRechargeItemsError: action.isConfigRechargeItemsError
            }
        case setConfigRechargeItemsColSearchStr:
            return {
                ...state,
                configRechargeItemsItems: action.data,
                isConfigRechargeItemsLoaded: action.isConfigRechargeItemsLoaded,
                isConfigRechargeItemsError: action.isConfigRechargeItemsError
            }
        case sortConfigRechargeItemsItems:
            return {
                ...state,
                configRechargeItemsItems: action.configRechargeItemsItems,
                configRechargeItemsColSort: action.configRechargeItemsColSort,
                configRechargeItemsIsSortedAsc: action.configRechargeItemsIsSortedAsc,
                isConfigRechargeItemsLoaded: action.isConfigRechargeItemsLoaded,
            }
        case setConfigRechargeItemsPageSize:
            return {
                ...state,
                configRechargeItemsItems: {
                    ...state.configRechargeItemsItems,
                    Pagination: {
                        ...state.configRechargeItemsItems.Pagination,
                        PerPage: action.pageSize
                    }
                }
            }
        case setDefaultConfigRechargeItems:
            return initialState;
        default:
            return state;
    }
};